import script from "./PaymentOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentOptions.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentOptions.vue?vue&type=style&index=0&id=156a8390&scoped=true&lang=css"
script.__scopeId = "data-v-156a8390"

export default script